import React, { useContext } from 'react'
import { ContentHeader } from '../../layout/Content'
import { customerAccountItemControllerContext } from './CustomerAccountItemController'
import CustomerAccountItemHeaderStyle from './css/CustomerAccountItemHeaderStyle'

function CustomerAccountItemHeader() {
  const customerAccountItemController = useContext(customerAccountItemControllerContext)
  const { customerAccount } = customerAccountItemController

  return (
    <ContentHeader>
      <div className='content-header-content'>
        <div className='header-title caption'>
          { `${(customerAccount) && customerAccount.customer_details.account_name}, Account Details` }
        </div>
      </div>
      <CustomerAccountItemHeaderStyle />
    </ContentHeader>
  )
}

export default React.memo(CustomerAccountItemHeader)
